module.exports = __webpack_public_path__ + "static/starting-strength-ce27e82eb412c08f0e285541b4ef482c.jpg";